import React from 'react';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { SidePage, Section } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import Actions from 'scenes/Influencers/InfluencersChannels/components/Actions';
import { InfluencerChannelFormEdit } from 'scenes/Influencers/InfluencersChannels/components/InfluencerChannelForm';
import {
  useLoadInfluencerChannelDetails,
  useIsUpdating,
} from 'scenes/Influencers/InfluencersChannels/data';

import InfluencerDetails from '../Influencers/components/InfluencerDetails/InfluencerDetails';
import Activity from './Activity';
import AgeAndGenders from './AgeAndGenders';
import Agencies from './Agencies';
import General from './General';
import MasterCampaigns from './MasterCampaigns';
import MetaData from './MetaData';

const InfluencerChannelDetails = ({ id, onClose, onExited, open }) => {
  const {
    data = {},
    isLoading,
    isRefetching,
  } = useLoadInfluencerChannelDetails(id);

  const isUpdating = useIsUpdating();

  const [childComponent, openChildComponent] = useChildComponent();

  const handleEdit = () => {
    openChildComponent(InfluencerChannelFormEdit, {
      id: data.id,
    });
  };

  const handleOpenInfluencer = (influencer) => {
    openChildComponent(InfluencerDetails, influencer);
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'Influencer Channel'}
        subTitle={get(data, 'name')}
        entityId={id}
      />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent>
          {!isEmpty(data) ? (
            <React.Fragment>
              <Section title={'General'}>
                <General data={data} onOpenInfluencer={handleOpenInfluencer} />
              </Section>
              <Section
                title={'Activity'}
                isCollapsable
                initialOpen={data?.subscribers}
              >
                <Activity data={data} />
              </Section>
              <Section
                title={`Agencies (${data?.agencies?.length})`}
                isCollapsable
                initialOpen={!!data?.agencies?.length}
              >
                <Agencies data={data?.agencies} />
              </Section>
              <Section
                title={'Age and Gender Distribution of Subscribes'}
                isCollapsable
                initialOpen={false}
              >
                <AgeAndGenders data={data?.ageGenderDistribution} />
              </Section>
              <Section
                title={`Master Campaigns (${data?.masterCampaigns?.length})`}
                isCollapsable
                initialOpen={false}
              >
                <MasterCampaigns data={data?.masterCampaigns} />
              </Section>
            </React.Fragment>
          ) : null}
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            <Actions
              data={data}
              actions={data?.actions}
              onDelete={onClose}
              onEdit={handleEdit}
            />
          }
        >
          <MetaData data={data} />
        </SidePage.Sidebar>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default InfluencerChannelDetails;
